import React from 'react';

export const AppTabPanel = ({ isActive, className = 'p-4', children }) => {
    return (
        <div className={`tab-pane fade ${className} ${isActive ? 'active show' : ''}`} role="tabpanel">
            {isActive ? children : null}
        </div>
    );
};
